<template>
  <div class="service_sonsult_list">
    <el-table
      :data="dataList"
      v-loading="dataLoading"
      border>
      <div class="no_show_message" slot="empty">
        <img src="@/assets/img/good/noGood.png" alt="暂无相关咨询">
        <div>暂无相关咨询</div>
      </div>
      <el-table-column type="index" header-align="center" align="center" width="50" label="No."></el-table-column>
      <el-table-column prop="serviceName" header-align="center" align="center" label="服务名称"></el-table-column>
      <el-table-column prop="status" header-align="center" align="center" label="是否受理" width="100px">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status">已受理</el-tag>
          <el-tag type="warning" v-else>未受理</el-tag>
          <!-- {{$getDictLabel('INQUIRY_ORDER_STATUS', scope.row.inquiryStatus)}} -->
        </template>
      </el-table-column>
      <el-table-column prop="createTime" header-align="center" align="center" label="咨询时间"></el-table-column>
      <el-table-column prop="acceptFeedback" header-align="center" align="center" label="受理反馈">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="left" width="250">
            <p class="line-break back_content">{{ scope.row.acceptFeedback }}</p>
            <div slot="reference" class="line-break ellipsis">
              {{ scope.row.acceptFeedback }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作" width="160">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="searchFileHandle(scope.row)">查看附件</el-button>
          <el-button type="text" size="small" @click="detailHandle(scope.row)">查看服务</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="dataForm.page"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="dataForm.limit"
                   :total="total"
                   layout="total, sizes, prev, pager, next, jumper"
                   @size-change="pageSizeChangeHandle"
                   @current-change="getDataList">
    </el-pagination>
    <el-dialog :visible.sync="visible"
              title="上传附件"
              :close-on-click-modal="false"
              width="30%">
      <el-upload
        :action="upLoadUrl"
        ref="imgUpload"
        :before-upload="beforeUpload"
        :accept="'.doc,.docx,.xls,.xlsx,.pdf'"
        :data="{ fileSuffixType: 'file1' }"
        :on-exceed="exceedHandle"
        :on-success="successHandle"
        :on-error="errorHandle"
        :with-credentials="true"
        :before-remove="beforeRemove"
        :headers="upLoadHeaders"
        :limit="9"
        :file-list="fileList">
        <el-button size="small" type="primary" :loading="loading">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传doc、docx、xls、xlsx或pdf文件,不超过20M</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleHandle()" :loading="loading">取 消</el-button>
        <el-button type="primary" @click="submitHandle()" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      dataLoading: false,
      dataList: [],
      total: 0,
      dataForm: {
        page: 1,
        limit: 10,
        consultationType: '10'
      },
      visible: false,
      loading: false,
      consultationId: '',
      fileList: [],
      fileListSave: [],
      delIds: [],
      upLoadHeaders: {
        'Authorization': 'Bearer ' + getAccessToken()
      },
      upLoadUrl: window.SITE_CONFIG['apiURL'] + '/help/fileupload/sys/v2/upload'
    }
  },
  mounted () {
    this.getDataList(1)
  },
  methods: {
    getDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      this.dataLoading = true
      this.$http.post(`/front/user/home/homeConsultationRecord/selectListByLoginUser`, this.dataForm)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.dataList = res.data.data || []
            this.total = res.data.count || 0
            return false
          } else {
            this.dataList = res.data.data || []
            this.total = res.data.count || 0
          }
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getDataList(1)
    },
    // 跳转详情页
    detailHandle (row) {
      this.$router.push({
        name: 'serviceContent',
        query: {
          id: row.serviceId
        }
      })
    },
    // 查看附件列表
    searchFileHandle (row) {
      if (this.$refs.imgUpload) {
        this.$refs.imgUpload.clearFiles()
      }
      this.delIds = []
      this.dataLoading = true
      this.consultationId = row.consultationId
      this.$http.get(`/front/user/home/homeConsultationRecord/info/${row.consultationId}`, {
        params: {
          consultationId: row.consultationId
        }
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          if (res.data.inquryConsultationOssVos && res.data.inquryConsultationOssVos.length) {
            this.fileList = res.data.inquryConsultationOssVos.map(item => {
              return {
                sysOssId: item.sysOssId,
                name: item.fileName,
                url: item.fileUrl
              }
            })
            this.fileListSave = res.data.inquryConsultationOssVos.map(item => {
              return {
                sysOssId: item.sysOssId,
                name: item.fileName,
                url: item.fileUrl
              }
            })
          } else {
            this.fileList = []
          }
          this.visible = true
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    beforeUpload (file) {
      let type = file.name.substring(file.name.lastIndexOf('.'))
      const isLt2M = file.size / 1024 / 1024 < 20
      var reg = /\.(doc|docx|xls|xlsx|pdf)$/
      const isJPG = reg.test(type)

      if (!isJPG) {
        this.$message.error('上传文件只能是 doc|docx|xls|xlsx|pdf 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 20MB!')
      }
      if (isJPG && isLt2M) {
        let newName = file.name.slice(0, file.name.lastIndexOf('.'))
        let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
        if (regx.test(newName)) {
        } else {
          this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
          return false
        }
        this.loading = true
      } else {
      }
      return isJPG && isLt2M
    },
    exceedHandle (files, fileList) {
      this.$message.warning(`当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    successHandle (response, file, fileList) {
      this.loading = false
      if (response.code === 0) {
        // this.$message({
        //   message: '上传成功',
        //   type: 'success'
        // })
        this.fileListSave.push({
          sysOssId: response.data.aliOssId,
          url: response.data.url,
          name: response.data.fileName
        })
      } else {
        this.$message({
          message: response.message,
          type: 'error'
        })
      }
    },
    errorHandle (err, file, fileList) {
      this.loading = false
      this.$message.error(err.message || '上传失败')
    },
    // 删除图片
    beforeRemove (file, fileList) {
      if (!file.response) {
        // 已保存关联的
        // this.deleteHandle([file.aliOssId])
        this.delIds.push(file.sysOssId)
        this.fileListSave.splice(
          this.fileListSave.findIndex(item => {
            return item.sysOssId === file.sysOssId
          }), 1)
      } else {
        // 未与咨询保存关联的
        this.deleteHandle([file.response.data.aliOssId])
        this.fileListSave.splice(
          this.fileListSave.findIndex(item => {
            return item.sysOssId === file.sysOssId
          }), 1)
      }
    },
    // 取消
    cancleHandle () {
      if (this.$refs.imgUpload) {
        this.$refs.imgUpload.clearFiles()
      }
      this.visible = false
      this.fileList = []
      this.fileListSave = []
    },
    // 提交附件
    submitHandle () {
      if (this.loading) {
        return false
      }
      this.loading = true
      let inquryConsultationOssForms = this.fileListSave.map(item => {
        return {
          sysOssId: item.sysOssId,
          consultationRecordId: this.consultationId
        }
      })
      this.$http.post(`/front/user/home/homeConsultationRecord/update`, {
        consultationId: this.consultationId,
        inquryConsultationOssForms: inquryConsultationOssForms
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.deleteHandle(this.delIds)
          this.cancleHandle()
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 删除阿里图片
    deleteHandle (ids = []) {
      if (ids.length) {
        this.$http.post(`help/fileupload/sys/deleteBatchAliOss`, ids)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.service_sonsult_list{
  .back_content{
    color: #fff;
    background: rgba(0,0,0,0.5);
  }
}
</style>
